import { IAPI } from '../../lib/models/api';
import { sms } from '@axo/shared/data-access/types';
import { send } from '../../lib/send.ts';

export interface OrttoSMSs {
  Items: sms.OrttoSMS[];
}

export function findOrttoSMSs({ url: { service: baseURL }, token }: IAPI) {
  return async ({
    customerID,
    marketCountry,
    createdAfter, //YYYY-MM-DD
    limit,
    offset,
  }: {
    customerID: string | undefined;
    marketCountry: string | undefined;
    createdAfter?: string;
    limit?: number;
    offset?: number;
  }): Promise<OrttoSMSs> => {
    const url = new URL('/sms-communication/ortto/sms', baseURL);
    if (customerID) url.searchParams.append('customerID', customerID);
    if (marketCountry) url.searchParams.append('marketCountry', marketCountry);
    if (limit) url.searchParams.append('limit', limit.toString());
    if (offset) url.searchParams.append('offset', offset.toString());
    if (createdAfter) {
      url.searchParams.append('createdAfter', createdAfter);
    } else {
      const date = new Date();
      date.setDate(date.getDate() - 90);
      url.searchParams.append('createdAfter', date.toISOString().split('T')[0]);
    }
    const response = await fetch(url, {
      method: 'GET',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
    });
    if (!response.ok) {
      throw new Error(`Network response was not OK: ${response.status}`);
    }
    return (await response.json()) as OrttoSMSs;
  };
}

export interface OrttoSMSBodies {
  Items: sms.OrttoSMSBody[];
}

export function getSMSBodies({ url: { service: baseURL }, token }: IAPI) {
  return async ({
    customerID,
    marketCountry,
  }: {
    customerID: string | undefined;
    marketCountry: string | undefined;
  }): Promise<OrttoSMSBodies> =>
    send({
      baseURL,
      token,
      path: `/sms-communication/ortto/sms-body?customerID=${customerID}&marketCountry=${marketCountry}`,
      method: 'GET',
    });
}
